import { useEffect, Suspense } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toastifyStyle.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "react-datepicker/dist/react-datepicker.css";
// Functions
import { isAISNProjectHospital } from "./config/projectFunctions";
// Redux
import { Provider, useSelector } from "react-redux";
import generateStore from "./redux/store";
// Components
import I18Next from "./i18n";

const ChatbotLoader = () => {
  const hospitalName = useSelector((state) => state?.clinician?.data?.HOSPITAL_NAME);

  useEffect(() => {
    const enableChatbot = async () => {
      try {
        const existingScript = document.getElementById("mims-chatbot-script");
        const existingWidget = document.getElementById("mims-chat-launcher");
        const existingOverlay = document.getElementById("mims-chat-overlay");

        if (!hospitalName) {
          if (existingScript) existingScript.remove();
          if (existingWidget) existingWidget.remove();
          if (existingOverlay) existingOverlay.remove();
          return;
        }

        const isAISN = await isAISNProjectHospital(hospitalName);

        if (isAISN) {
          if (existingScript && (existingWidget || existingOverlay)) {
            return;
          }

          const script = document.createElement("script");
          script.id = "mims-chatbot-script";
          script.src = "https://mims-chatbot.eodyne.com/chat-widget.js?ts=" + Date.now();
          script.async = true;
          script.setAttribute("data-chat-src", "https://mims-chatbot.eodyne.com");

          document.body.appendChild(script);
        } else {
          if (existingScript) existingScript.remove();
          if (existingWidget) existingWidget.remove();
          if (existingOverlay) existingOverlay.remove();
        }
      } catch (e) {
        console.error("Error loading chatbot widget:", e);
      }
    };

    enableChatbot();
  }, [hospitalName]);

  return null;
};

function App() {
  const store = generateStore();

  return (
    <Provider store={store}>
      <ChatbotLoader />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        limit={2}
        rtl={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Suspense fallback={<div>Loading...</div>}>
        <I18Next />
      </Suspense>
    </Provider>
  );
}

export default App;
